<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR REQUERIMENTO' : 'NOVO REQUERIMENTO'" titleIcon="fas fa-clipboard-list">
            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Tipo" prop="tipo_requerimento_id" :rules="[$requiredChange]">
                            <el-select v-model="form.tipo_requerimento_id" filterable style="width:100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Aberto em">
                            <el-date-picker v-model="form.data_abertura" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Protocolo">
                            <el-input v-model="form.numero_protocolo" placeholder="Auto se vazio"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-tabs v-model="abaSolicitante" type="border-card">
                    <el-tab-pane label="Aluno" name="aluno">
                        <el-form-item label="Aluno">
                            <el-select v-model="form.aluno_id" filterable remote :remote-method="buscarAluno"
                                :loading="loadAluno" placeholder="Digite o nome..." style="width:100%;"
                                @change="onSelecionarAluno">
                                <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="Servidor" name="servidor">
                        <el-form-item label="Servidor">
                            <el-select v-model="form.servidor_id" filterable remote :remote-method="buscarServidor"
                                :loading="loadServidor" placeholder="Digite o nome..." style="width:100%;"
                                @change="onSelecionarServidor">
                                <el-option v-for="s in servidoresBusca" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="Outro (texto livre)" name="outro">
                        <el-row :gutter="10">
                            <el-col :sm="14">
                                <el-form-item label="Nome do solicitante">
                                    <el-input v-model="form.solicitante_nome"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="10">
                                <el-form-item label="Documento">
                                    <el-input v-model="form.solicitante_documento"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>

                <el-form-item label="Descrição do pedido" prop="descricao" :rules="[$requiredBlur]">
                    <el-input type="textarea" v-model="form.descricao" :rows="5"></el-input>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/requerimento"><el-button>VOLTAR</el-button></router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            form: this.formVazio(),
            modoEdicao: false,
            tipos: [],
            abaSolicitante: 'aluno',
            alunosBusca: [], loadAluno: false,
            servidoresBusca: [], loadServidor: false
        }
    },
    mounted () {
        this.carregarTipos()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        } else {
            this.form.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
            this.form.data_abertura = new Date().toISOString().slice(0, 10)
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        formVazio () {
            return {
                instituicao_id: null, tipo_requerimento_id: null,
                aluno_id: null, servidor_id: null,
                solicitante_nome: '', solicitante_documento: '',
                numero_protocolo: '', data_abertura: null,
                descricao: ''
            }
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/requerimento/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                Object.keys(this.form).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.form[k] = reg[k] })
                if (reg.aluno) { this.alunosBusca = [reg.aluno]; this.abaSolicitante = 'aluno' }
                if (reg.servidor) { this.servidoresBusca = [reg.servidor]; this.abaSolicitante = 'servidor' }
                if (!reg.aluno && !reg.servidor && reg.solicitante_nome) this.abaSolicitante = 'outro'
            })
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-requerimento/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunosBusca = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        buscarServidor (q) {
            if (!q || q.length < 2) { this.servidoresBusca = []; return }
            this.loadServidor = true
            this.$axios.post(`${this.baseUrl()}/api/servidor/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.servidoresBusca = r.data || []; this.loadServidor = false })
                .catch(() => { this.loadServidor = false })
        },
        onSelecionarAluno () { this.form.servidor_id = null; this.form.solicitante_nome = '' },
        onSelecionarServidor () { this.form.aluno_id = null; this.form.solicitante_nome = '' },
        salvar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                // Limpa campos não-relevantes conforme aba
                const payload = { ...this.form }
                if (this.abaSolicitante !== 'aluno') payload.aluno_id = null
                if (this.abaSolicitante !== 'servidor') payload.servidor_id = null
                if (this.abaSolicitante !== 'outro') { payload.solicitante_nome = null; payload.solicitante_documento = null }

                const url = this.modoEdicao
                    ? `${this.baseUrl()}/api/requerimento/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/requerimento/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                    this.$router.push('/admin/requerimento')
                })
            })
        }
    }
}
</script>
